var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stock-obv-view"},[_c('StockOBV')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }